import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import Layout from '../../components/Layout';
import InvoiceDetails from "../../components/Invoice/Details";
import Toolbar from "../../components/Toolbar/Toolbar";
import i18n from "../../i18n";
import Grid from "@material-ui/core/Grid/Grid";
import InvoiceCosts from "../../components/Invoice/InvoiceCosts";
import ShortCards from "../../components/File/ShortCards";
import {faFilePdf} from "@fortawesome/free-solid-svg-icons/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const icn = (iconType, classes) => {
    return <FontAwesomeIcon icon={iconType} className={classes.tabBarButtonIcon}/>;
}

const InvoiceShow = ({classes, invoice, invoice_type}) => {
    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('invoice.title.show')}
                items={[
                    {
                        fontawesome: icn(faFilePdf, classes),
                        text: i18n.get('invoice.download_pdf'),
                        href: invoice_type === "person" ? `/pdf/royalty/${invoice.id}` : `/pdf/board/${invoice.id}`
                    }
                ]}
            />

            <div className={classes.layout}>
                <Grid container spacing={24}>
                    <Grid item sm={12} lg={6}>
                        <InvoiceDetails
                            invoice={invoice}
                        />
                    </Grid>
                    <Grid item sm={12} lg={6}>
                        <InvoiceCosts
                            invoice={invoice}
                            invoice_type={invoice_type}
                        />
                    </Grid>
                </Grid>
            </div>

            {/*<Toolbar*/}
                {/*disableGutters*/}
                {/*title={i18n.get('invoice.title.files')}*/}
            {/*/>*/}
            {/*<div className={classes.layout}>*/}
                {/*<ShortCards*/}
                    {/*invoice={invoice}*/}
                {/*/>*/}
            {/*</div>*/}
        </Layout>
    )
};

const styles = theme => ({
    layout: {
        width: 'auto',
    },
    paper: {
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
    },
    tabBarButtonIcon: {
        marginRight: theme.spacing.unit,
    },
});


export default withStyles(styles)(InvoiceShow);


// WEBPACK FOOTER //
// ./resources/assets/js/pages/invoice/Show.jsx